<template>
  <Dialog :title="$t('Cliente')" v-model="show">
    <!-- Contenido del Dialog, Formulario -->
    <template v-slot:content>
      <ValidationObserver ref="ValidationObserver">
        <v-form ref="form" lazy-validation v-if="cliente">
          <v-tabs class="elevation-2 pa-2" grow>
            <!-- Cabecera del tab -->
            <v-tab href="#tab-datosbasicos">
              <span class="tab_title">{{ $t('Datos básicos') }}</span>
            </v-tab>
            <!-- Contenido del tab datos básicos -->
            <v-tab-item value="tab-datosbasicos" class="pa-4 grey lighten-5">
              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-text-field
                      v-model="cliente.nombre"
                      :rules="[required]"
                      :label="$t('Nombre')"
                      outlined
                      dense
                  />
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-text-field
                      v-model="cliente.apellido1"
                      :label="$t('Primer apellido')"
                      outlined
                      dense
                  />
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-text-field
                      v-model="cliente.apellido2"
                      :label="$t('Segundo apellido')"
                      outlined
                      dense
                  />
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-select
                      :label="$t('Sexo')"
                      v-model="cliente.sexo"
                      :items="data_form.sexos"
                      item-text="text"
                      item-value="id"
                      dense
                      outlined
                  />
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col cols="2" class="pa-0">
                  <v-text-field
                    v-model="cliente.prefijo_tel"
                    :class="visible_movil ? '' : 'blurred'"
                    :disabled="!visible_movil"
                    :rules="[ validate_length(cliente.prefijotel, 3), validate_integer(cliente.prefijotel, 0), only_integer(cliente.prefijotel) ]"
                    :label="$t('Prefijo')"
                    outlined
                    dense
                    type="number"
                  >
                    <template #prepend-inner>
                      <span class="mt-1">+</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="10" class="pa-0">
                  <v-text-field
                      v-model="cliente.movil"
                      :class="visible_movil ? '' : 'blurred'"
                      :disabled="!visible_movil"
                      :rules="[ validate_length(cliente.movil, 16), validate_integer(cliente.movil, 0), only_integer(cliente.movil) ]"
                      :label="$t('Teléfono móvil')"
                      outlined
                      dense
                      type="number"
                  />
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col cols="12" class="pa-0"/>
                <v-col cols="12" class="pa-0">
                  <v-text-field
                      v-model="cliente.email"
                      :class="visible_email ? '' : 'blurred'"
                      :disabled="!visible_email"
                      :rules="[validate_email]"
                      :label="$t('Email')"
                      outlined
                      dense
                      type="text"
                  />
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-autocomplete
                      :label="$t('Provincia')"
                      :rules="[required]"
                      v-model="cliente.provincia"
                      :items="data_form.provincias"
                      item-text="text"
                      item-value="id"
                      dense
                      outlined
                  />
                </v-col>
              </v-row>

              <v-row class="ma-0" v-if="data_form.categorias && data_form.categorias.length">
                <v-col cols="12" class="pa-0">
                  <v-autocomplete
                      :label="$t('Categoría')"
                      v-model="cliente.categoria"
                      :items="data_form.categorias"
                      item-text="text"
                      item-value="value"
                      hide-no-data
                      dense
                      outlined
                      clearable
                  />
                </v-col>
              </v-row>
            </v-tab-item>

            <!-- Cabecera del tab -->
            <v-tab href="#tab-datosadicionales">
              <span class="tab_title">{{ $t('Datos adicionales') }}</span>
            </v-tab>
            <!-- Contenido del tab -->
            <v-tab-item value="tab-datosadicionales" class="pa-4 grey lighten-5">

              <v-row class="ma-0">
                <v-col cols="6">
                  <v-row class="ma-0">
                    <v-col cols="12" class="pa-0" style="margin-bottom: 5px">
                      <v-text-field
                          v-model="cliente.code"
                          :label="$t('Código')"
                          outlined
                          dense
                          hide-details
                          type="number"
                      />
                      <template v-if="data_form.old_codigo">{{ $t('Último código de cliente:') }}
                        {{ data_form.old_codigo }}
                      </template>
                      <div v-else style="margin-bottom: 21px"></div>
                    </v-col>
                  </v-row>

                  <v-row class="ma-0 mb-6">
                    <v-col cols="12" class="pa-0" style="margin-bottom: 5px">
                      <v-text-field
                          v-model="cliente.manual_code"
                          :label="$t('Código manual')"
                          outlined
                          dense
                          hide-details
                      />
                    </v-col>
                  </v-row>

                  <v-row class="ma-0 mb-6">
                    <v-col cols="12" class="pa-0">
                      <ValidationProvider
                          rules="required"
                          :name="$t('FechaNacimiento').toLowerCase()"
                          v-slot="{ errors, classes }"
                      >
                        <div class="control" :class="classes">
                          <DatePicker
                              v-model="cliente.fecha_nacimiento"
                              :title="$t('Fecha de nacimiento')"
                              outlined
                              dense
                              clearable
                              :allow_future="false"
                          />
                        </div>
                      </ValidationProvider>
                    </v-col>
                  </v-row>

                  <v-row class="ma-0">
                    <v-col cols="12" class="pa-0">
                      <v-text-field
                          v-model="cliente.fijo"
                          :class="visible_fijo ? '' : 'blurred'"
                          :disabled="!visible_fijo"
                          :rules="[ validate_length(cliente.fijo, 16), validate_integer(cliente.fijo, 0), only_integer(cliente.fijo) ]"
                          :label="$t('Teléfono fijo')"
                          type="number"
                          outlined
                          dense
                      />
                    </v-col>
                  </v-row>

                  <v-row class="ma-0">
                    <v-col cols="12" class="pa-0">
                      <v-text-field
                          v-model="cliente.dni"
                          :label="$t('Nº identificación personal')"
                          outlined
                          dense
                      />
                    </v-col>
                  </v-row>

                  <v-row class="ma-0">
                    <v-col cols="12" class="pa-0">
                      <v-text-field
                          v-model="cliente.direccion"
                          :class="visible_direccion? '' : 'blurred'"
                          :disabled="!visible_direccion"
                          :label="$t('Dirección')"
                          outlined
                          dense
                      />
                    </v-col>
                  </v-row>

                  <v-row class="ma-0">
                    <v-col cols="12" class="pa-0">
                      <v-text-field
                          v-model="cliente.localidad"
                          :label="$t('Localidad')"
                          outlined
                          dense
                      />
                    </v-col>
                  </v-row>

                  <v-row class="ma-0">
                    <v-col cols="12" class="pa-0">
                      <v-text-field
                          v-model="cliente.codigo_postal"
                          :label="$t('Código postal')"
                          outlined
                          dense
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="6">

                  <v-row class="ma-0">
                    <v-col cols="12" class="pa-0">
                      <v-textarea
                          clear-icon="mdi-close-circle"
                          :label="$t('Información clínica')"
                          rows="7"
                          v-model="cliente.informacion_clinica"
                          outlined
                      />
                    </v-col>
                  </v-row>

                  <v-row class="ma-0">
                    <v-col cols="12" class="pa-0">
                      <v-textarea
                          clear-icon="mdi-close-circle"
                          :label="$t('Notas')"
                          rows="7"
                          v-model="cliente.notas"
                          outlined
                      />
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-tab-item>

            <!-- Cabecera del tab -->
            <v-tab href="#tab-configuracion">
              <span class="tab_title">{{ $t('Configuración') }}</span>
            </v-tab>
            <!-- Contenido del tab -->
            <v-tab-item value="tab-configuracion" class="pa-4 grey lighten-5">

              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-autocomplete
                      :label="$t('¿Cómo nos conoció?')"
                      v-model="cliente.como_nos_conocio"
                      :items="data_form.como_nos_conocio"
                      dense
                      clearable
                      outlined
                  />
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-text-field
                      v-model="cliente.descuento_ventas"
                      :label="$t('Descuento en ventas')"
                      type="number"
                      outlined
                      dense
                      append-icon="mdi-percent-outline"
                  />
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-switch
                      v-model="cliente.is_envios_sms"
                      :label="$t('Envíos SMS')"
                  />
                </v-col>
              </v-row>

              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-switch
                      v-model="cliente.is_envios_email"
                      :label="$t('Envíos email')"
                  />
                </v-col>
              </v-row>

              <v-divider/>

              <v-row class="ma-0">
                <v-col cols="12" class="pa-0">
                  <v-switch
                      v-model="cliente.is_active"
                      :label="$t('Activo')"
                  />
                </v-col>
              </v-row>
            </v-tab-item>

            <!-- Cabecera del tab -->
            <v-tab href="#tab-rgpd">
              <span class="tab_title">{{ $t('RGPD') }}</span>
            </v-tab>
            <!-- Contenido del tab -->
            <v-tab-item value="tab-rgpd" class="pa-4 grey lighten-5">
              <v-textarea outlined :label="$t('Política de privacidad')" v-model="data_form.politica_privacidad_rgpd"
                          readonly/>
              <v-switch :label="$t('Estoy de acuerdo y acepto la Política de Privacidad')"
                        v-model="cliente.is_agree_rgpd" :disabled="aceptar_rgpd_disabled" @click="open_dialog_signature"/>
              <v-switch :label="$t('Acepto recibir comunicaciones y notificaciones por SMS')"
                        v-model="cliente.is_agree_notificaciones_sms"/>
              <v-switch :label="$t('Acepto recibir comunicaciones y notificaciones por correo electrónico')"
                        v-model="cliente.is_agree_notificaciones_email"/>
              <v-row align="center" justify="center" v-if="cliente.b64_firma_rgpd || cliente.fecha_firma_rgpd">
                <v-col v-if="cliente.b64_firma_rgpd">
                  <v-img :src="cliente.b64_firma_rgpd" width="300px"
                         style="border-style: solid; border-radius: 25px; border-width: 1px"/>
                </v-col>
                <v-col align-self="center" v-if="cliente.fecha_firma_rgpd">
                  <p>{{ $t('Firmado:') }} {{ cliente.fecha_firma_rgpd | moment('LLLL') }}</p>
                </v-col>
              </v-row>
            </v-tab-item>
          </v-tabs>
        </v-form>
      </ValidationObserver>
      <DialogSignature ref="dialog_signature" @on_save_signature="set_signature" />
    </template>
    <!-- Acciones de la derecha del dialog -->
    <template v-slot:right-action>
      <v-btn @click="save" small class="primary">
        <v-icon small>mdi-content-save</v-icon>
        {{ $t('Guardar') }}
      </v-btn>
    </template>
  </Dialog>
</template>


<script>
import rules from "@/rules";
import {ValidationProvider, ValidationObserver} from 'vee-validate'
import CONSTANTS from "@/utils/constants";
import Swal from "sweetalert2";

export default {
  name: 'FormCliente',
  data() {
    return {
      CONSTANTS,
      cliente: {},
      data_form: {},
      aceptar_rgpd_disabled: false,
      visible_movil: false,
      visible_email: false,
      visible_fijo: false,
      visible_direccion: false,
    }
  },
  methods: {
    /**
     * Recupera los datos de los desplegables del formulario cliente
     * @returns {Promise<void>}
     */
    async get_cliente_form() {
      if (!this.cliente.id) {
        this.data_form = await this.$store.dispatch('cliente/get_form', {new_cliente: true})
        this.cliente.provincia = this.$store.state.centro.centro.provincia
        this.cliente.code = this.data_form.new_codigo
      } else {
        this.data_form = await this.$store.dispatch('cliente/get_form')
          if (!this.cliente.provincia) {
            this.cliente.provincia = this.$store.state.centro.centro.provincia
          }
      }
    },

    // Reglas del formulario
    required(value) {
      return rules.required(value);
    },

    validate_length(value, max) {
      return rules.validate_length(value, max)
    },

    validate_email(value) {
      return rules.validate_email(value);
    },

    validate_integer(value, num) {
      return rules.validate_integer(value, num);
    },

    only_integer(value) {
      return rules.only_integer(value);
    },

    async save() {
      let text = ''
      if (this.$refs.form.validate()) {
        this.cliente.code = this.cliente.code === '' ? null : this.cliente.code
        if (this.$store.state.centro.centro.is_rgpd_active && !this.cliente.b64_firma_rgpd) {
          const resp = await this.$confirm(this.$t('El cliente no ha firmado la RGPD, ¿continuar?'))
          if (!resp) {
            return
          }
        }
        try {
          const cliente_duplicado = await this.$store.dispatch('cliente/check_cliente_duplicado', this.cliente)
          if (cliente_duplicado.cliente.value && !this.cliente.id) {
            switch (cliente_duplicado.duplicate_code) {
              case CONSTANTS.DUPLICAR_CLIENTE.EMAIL:
                text = 'El cliente [NOMBRE_CLIENTE] también tiene el email [EMAIL_CLIENTE].'
                text = text.replace('[NOMBRE_CLIENTE]', cliente_duplicado.cliente.text)
                text = text.replace('[EMAIL_CLIENTE]', cliente_duplicado.cliente.email)

                await this.open_confirm_duplicar(text)
                break
              case CONSTANTS.DUPLICAR_CLIENTE.MOVIL:
                text = 'El cliente [NOMBRE_CLIENTE] también tiene el número de teléfono [MOVIL_CLIENTE].'
                text = text.replace('[NOMBRE_CLIENTE]', cliente_duplicado.cliente.text)
                text = text.replace('[MOVIL_CLIENTE]', cliente_duplicado.cliente.movil)

                await this.open_confirm_duplicar(text)
                break

              case CONSTANTS.DUPLICAR_CLIENTE.FIJO:
                text = 'El cliente [NOMBRE_CLIENTE] también tiene el número de teléfono fijo [FIJO_CLIENTE].'
                text = text.replace('[NOMBRE_CLIENTE]', cliente_duplicado.cliente.text)
                text = text.replace('[FIJO_CLIENTE]', cliente_duplicado.cliente.fijo)
                await this.open_confirm_duplicar(text)
                break

              case CONSTANTS.DUPLICAR_CLIENTE.DNI:
                text = 'El cliente [NOMBRE_CLIENTE] también tiene el DNI [DNI_CLIENTE].'
                text = text.replace('[NOMBRE_CLIENTE]', cliente_duplicado.cliente.text)
                text = text.replace('[DNI_CLIENTE]', cliente_duplicado.cliente.dni)
                await this.open_confirm_duplicar(text)
                break
              case CONSTANTS.DUPLICAR_CLIENTE.NOMBRE_COMPLETO:
                text = 'Ya existe un cliente con el nombre [NOMBRE_CLIENTE].'
                text = text.replace('[NOMBRE_CLIENTE]', cliente_duplicado.cliente.text)
                await this.open_confirm_duplicar(text)
                break
            }
          }else{
            this.cliente = await this.$store.dispatch('cliente/save', this.cliente)
            this.$snotify.success(
              this.$t("Acción realizada con éxito"),
              this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
            )
            this.$emit('on_save', this.cliente)
          }
        } catch (e) {
          this.cliente = await this.$store.dispatch('cliente/save', this.cliente)
          this.$snotify.success(
            this.$t("Acción realizada con éxito"),
            this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
          )
          this.$emit('on_save', this.cliente)
        }
      }
    },

   async open_confirm_duplicar(text){
      const confirm = await this.$fire({
        html: this.$t(text) + '<br><br>' + this.$t('¿Guardar el cliente de todos modos?'),
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: this.$t('Guardar'),
        cancelButtonText: this.$t('Cancelar'),
      })

     if (confirm.value === true) {
       this.cliente = await this.$store.dispatch('cliente/save', this.cliente)
       this.$snotify.success(
         this.$t("Acción realizada con éxito"),
         this.$t('Atención {0}', [this.$store.getters['auth/user'].first_name])
       )
       this.$emit('on_save', this.cliente)
     } else if (confirm.dismiss === Swal.DismissReason.cancel) {
       // pass
     }
    },

    set_fijo_visible() {
      if (this.cliente.fijo && (this.$store.state.auth.user.tipo_empleado !== 'admin' && !this.$store.getters['auth/has_permission']('ver_fijo_cliente'))) {
        this.visible_fijo = false
      } else if (this.cliente.fijo && (this.$store.state.auth.user.tipo_empleado === 'admin' || this.$store.getters['auth/has_permission']('ver_fijo_cliente'))) {
        this.visible_fijo = true
      } else if (!this.cliente.fijo && (!this.$store.getters['auth/has_permission']('ver_fijo_cliente'))) {
        this.visible_fijo = true
      } else if (this.cliente.fijo && (this.$store.state.auth.user.tipo_empleado === 'admin')) {
        this.visible_fijo = true
      } else if (!this.cliente.fijo && (this.$store.getters['auth/has_permission']('ver_fijo_cliente'))) {
        this.visible_fijo = true
      }
    },

    set_movil_visible() {
      if (this.cliente.movil && (this.$store.state.auth.user.tipo_empleado !== 'admin' && !this.$store.getters['auth/has_permission']('ver_movil_cliente'))) {
        this.visible_movil = false
      } else if (this.cliente.movil && (this.$store.state.auth.user.tipo_empleado === 'admin' || this.$store.getters['auth/has_permission']('ver_movil_cliente'))) {
        this.visible_movil = true
      } else if (!this.cliente.movil && (!this.$store.getters['auth/has_permission']('ver_movil_cliente'))) {
        this.visible_movil = true
      } else if (this.cliente.movil && (this.$store.state.auth.user.tipo_empleado === 'admin')) {
        this.visible_movil = true
      }else if (!this.cliente.movil && (this.$store.getters['auth/has_permission']('ver_movil_cliente'))) {
        this.visible_movil = true
      }
    },

    set_email_visible() {
      if (this.cliente.email && (this.$store.state.auth.user.tipo_empleado !== 'admin' && !this.$store.getters['auth/has_permission']('ver_email_cliente'))) {
        this.visible_email = false
      } else if (this.cliente.email && (this.$store.state.auth.user.tipo_empleado === 'admin' || this.$store.getters['auth/has_permission']('ver_email_cliente'))) {
        this.visible_email = true
      } else if (!this.cliente.email && (!this.$store.getters['auth/has_permission']('ver_email_cliente'))) {
        this.visible_email = true
      }else if (this.cliente.email && (this.$store.state.auth.user.tipo_empleado === 'admin')) {
        this.visible_email = true
      }else if (!this.cliente.email && (this.$store.getters['auth/has_permission']('ver_email_cliente'))) {
        this.visible_email = true
      }
    },

    set_direccion_visible() {
      this.visible_direccion = !((this.$store.state.auth.user.tipo_empleado !== 'admin' &&
          !this.$store.getters['auth/has_permission']('ver_direccion_cliente')) && !!this.cliente.direccion);
    },

    open_dialog_signature(){
      if (this.cliente.is_agree_rgpd) {
        this.$refs.dialog_signature.open_dialog()
      }
    },

    set_signature(signature){
      this.cliente.b64_firma_rgpd = signature
    },
  },

  computed: {
    show: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
  },

  async mounted() {
    this.cliente = {...this.item}
    this.set_fijo_visible()
    this.set_movil_visible()
    this.set_email_visible()
    this.set_direccion_visible()
    if (this.cliente.fecha_firma_rgpd) this.aceptar_rgpd_disabled = !!this.cliente.b64_firma_rgpd
    const response = await this.$store.dispatch('configuraciones/get', 'rgpd')

    if (!this.cliente.id) {
      this.cliente.is_envios_email = true
      this.cliente.is_envios_sms = true
      this.cliente.is_agree_notificaciones_email = response.is_comunicaciones_clientes_default
      this.cliente.is_agree_notificaciones_sms = response.is_comunicaciones_clientes_default
    }

    await this.get_cliente_form()
  },

  props: ['value', 'item', 'titulo'],

  components: {
    ValidationObserver,
    ValidationProvider,
    DialogSignature: () => import('@/components/shared/DialogSignature'),
  },

}
</script>
<style lang="scss" scoped>
/* Ocultamos las flechitas de los campos de números */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

input[type=number] {
  -moz-appearance: textfield;
}
</style>
